import StepForm from './StepForm'
import Navbar from '../navbar/Navbar'
import Footer from '../footer/Footer'

function Steps() {
  return (
    <>
        <Navbar />
      <StepForm />
      <Footer />
    </>
  )
}

export default Steps
